module.exports = __webpack_public_path__ + "static/use-case-1-content-5-8f8ea6e982be370a4678d20e8a471dc4.png";